export default __webpack_public_path__ + "static/media/ch_void.d2258d21.svg";